(() => {
  if (customElements.get('luemas-reviews-marquee')) return;

  class LuemasReviewsMarquee extends HTMLElement {
    constructor() {
      super();
      this.updateDuration = this.updateDuration.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('[data-review-track]');
      this.group = this.querySelector('[data-review-group]');
      this.speed = Math.max(Number(this.dataset.speed) || 45, 1);
      this.autoMove = this.dataset.autoMove === 'true';

      if (!this.track || !this.group) return;

      this.updateDuration();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.updateDuration);
        this.resizeObserver.observe(this.group);
      } else {
        window.addEventListener('resize', this.updateDuration, { passive: true });
      }

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', () => {
          this.track.style.animationPlayState = 'paused';
        });
        this.addEventListener('shopify:block:deselect', () => {
          this.track.style.animationPlayState = '';
        });
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('resize', this.updateDuration);
    }

    updateDuration() {
      if (!this.autoMove || !this.group || !this.track) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 22;
      const travelDistance = this.group.scrollWidth + gap;
      const duration = Math.max(travelDistance / this.speed, 8);
      this.style.setProperty('--luemas-review-duration', `${duration}s`);
    }
  }

  customElements.define('luemas-reviews-marquee', LuemasReviewsMarquee);
})();
